import axios from 'axios';
import { put, takeLatest, call } from 'redux-saga/effects';
import * as types from '../ActionTypes/ProfileActionTypes';
import { profile } from '../../BusinessLogic/Network/API/ProfileApi';
import { ProfileActionCreators } from '../ActionCreators/ProfileActionCreators';

export class ProfileSaga {
    static *getUserProfile({ meta: { userId } }) {
        try {
            const _profile = profile.create();
            const { data: response } = yield call(axios, _profile.getProfile(userId));
            yield put(ProfileActionCreators.getUserProfileSuccess({ ...response.data, stats: { ...response.meta } }));
        } catch (error) {
            yield put(ProfileActionCreators.getUserProfileFailed(error));
        }
    }

    static *getFollowers({ meta: { userId } }) {
        try {
            const _profile = profile.create();
            const { data: response } = yield call(axios, _profile.getFollowrs(userId));
            yield put(ProfileActionCreators.getProfileFollowersSuccess(response.data));
        } catch (error) {
            yield put(ProfileActionCreators.getProfileFollowersFailed(error));
        }
    }
}

export function* saga() {
    yield takeLatest(types.GET_USER_PROFILE_REQUEST, ProfileSaga.getUserProfile);
    yield takeLatest(types.GET_PROFILE_FOLLOWERS_REQUEST, ProfileSaga.getFollowers);
}



// WEBPACK FOOTER //
// ./src/Store/Saga/ProfileSaga.js